import './play-by-play.styles.scss';

// Play-by-play from a simulated game (result.pbp), grouped by period.
// periodsInRegulation: 2 for halves, 4 for quarters.
const PlayByPlay = ({ pbp, homeName, awayName, periodsInRegulation }) => {

    const periodLabel = (n) => {
        if (n > periodsInRegulation) {
            const ot = n - periodsInRegulation;
            return ot === 1 ? 'Overtime' : `Overtime ${ot}`;
        }
        if (periodsInRegulation === 2) return n === 1 ? '1st Half' : '2nd Half';
        return `${['1st', '2nd', '3rd', '4th'][n - 1]} Quarter`;
    };

    const groups = [];
    for (const e of pbp) {
        if (!groups.length || groups[groups.length - 1].period !== e.period) {
            groups.push({ period: e.period, events: [] });
        }
        groups[groups.length - 1].events.push(e);
    }

    return (
        <div className='play-by-play'>
            {groups.map(g => (
                <section key={g.period}>
                    <div className='pbp-period'>{periodLabel(g.period)}</div>
                    {g.events.map((e, i) => (
                        <div key={i} className={`pbp-row ${e.side ?? 'neutral'}`}>
                            <span className='pbp-clock'>{e.clock}</span>
                            <span className='pbp-team'>{e.side === 'home' ? homeName : e.side === 'away' ? awayName : ''}</span>
                            <span className='pbp-text'>{e.text}</span>
                            <span className='pbp-score'>{e.away}-{e.home}</span>
                        </div>
                    ))}
                </section>
            ))}
        </div>
    )
}

export default PlayByPlay
